import React, { ReactNode, useCallback, useState, useEffect } from "react";
import { TableVirtuoso } from "react-virtuoso";
import ReportsNotFound from "components/Reports/ReportsBase/reportsNotFound";
import { TabTypes } from "../UsersPermissionsManagementTypes";

type IColumn<T> = {
  title: string;
  dataIndex: number;
  flex: number;
  renderCell: (cell: string | boolean | number | Date | T) => JSX.Element;
  maxWidth?: number;
};

interface RenderListProps<T> {
  columns: IColumn<T>[];
  data: T[];
  type: TabTypes;
}

const RenderList = <T,>({
  columns = [],
  data = [],
  type,
}: RenderListProps<T>) => {
  const [rows, setRows] = useState<T[]>(
    data?.map((item) => ({
      ...item,
    }))
  );

  useEffect(() => {
    setRows(
      data?.map((item) => ({
        ...item,
      }))
    );
  }, [data]);

  const renderHeader = useCallback((): ReactNode => {
    return (
      <tr>
        {columns.map((column) => (
          <th
            style={{
              flex: column.flex,
              maxWidth: column?.maxWidth,
              textAlign: "center",
            }}
            key={column.dataIndex}
          >
            {column.title}
          </th>
        ))}
      </tr>
    );
  }, [columns]);

  const renderItems = useCallback(
    (index: number, item: T) => {
      const field = type === "volunteers" ? "userApp" : "disable";
      const disableField =
        type === "volunteers" ? item[field]?.disable : item[field];

      return (
        <tr
          className="tab-list-item"
          style={{
            opacity: disableField ? "0.5" : "1",
          }}
          key={index}
        >
          {columns.map((column) => (
            <td
              style={{
                maxWidth: column?.maxWidth,
                flex: column.flex,
                textAlign: "center",
              }}
              key={column.dataIndex}
            >
              {column.renderCell(item)}
            </td>
          ))}
        </tr>
      );
    },
    [columns, type]
  );

  return (
    <>
      <TableVirtuoso
        data={rows}
        fixedHeaderContent={renderHeader}
        itemContent={renderItems}
        className="table-virtuoso"
      />
      {data?.length === 0 && <ReportsNotFound />}
    </>
  );
};

export default RenderList;
